import React, { useEffect, useReducer, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import Button from "@material-ui/core/Button";
import AuthMiddleware from "../../../store/middleware/authMiddleware";
import { connect, useDispatch } from "react-redux";
import './style.scss'
import $ from 'jquery'
const useStyles = makeStyles((theme) => ({
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    paper: {
        backgroundColor: theme.palette.background.paper,
        border: '2px solid #000',
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 4, 3),
    },
}));

const initialState = {
    error: {}
}

function reducer(state, action) {
    switch (action.type) {
        case 'ON_ERROR':
            return { ...state, error: { ...action.payload } }
        default:
            return state;
    }
}

function ChangePasswordAfterLogin(props) {
    const classes = useStyles();
    const [open, setOpen] = React.useState(props.flag);

    const [email, setEmail] = useState('');
    const [currentPassword, setCurrentPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [state, dispatch] = useReducer(reducer, initialState)
    const [userData, setUserData] = useState({})
    // const store = useSelector(store => store)
    const dispatch_ = useDispatch()

    useEffect(() => {
        let user = JSON.parse(localStorage.getItem("myData"))
        setUserData(user)
        setEmail(user.user.username)
        
    }, [])
    $(document).ready(function() {
        $('#mypassword').bind("cut copy paste", function(e) {
            e.preventDefault();
                alert("You cannot paste into this text field.");
            $('#mypassword').bind("contextmenu", function(e) {
                e.preventDefault();
            });
        });
    });
    // window.onload = () => {
    //     const myPasswordInput = document.getElementById('mypassword');
    //     myPasswordInput.onpaste = e => e.preventDefault();
    //    }
    function handleChangePassword() {
        const isValidate = checkValidation()
        if (isValidate) {
            const body = {
                password: newPassword,
                oldPassword: currentPassword,
                email: email
            }
            dispatch_(AuthMiddleware.userChangePassword(body, userData.user.guid, userData.access_token, props.history))
        }
    }

    function checkValidation() {
        const error = {};
        if (!currentPassword.trim()) {
            error.currentPassword = 'Please enter current password'
        }
        if (!newPassword.trim()) {
            error.newPassword = 'Please enter new password'
        } else {
            if (newPassword.trim().length < 8) {
                error.newPassword = 'New password must be greater or equal to 8'
            }
        }
        if (!confirmPassword.trim()) {
            error.confirmPassword = 'Please enter confirm password'
        }
        if (confirmPassword !== newPassword) {
            error.passwordMatch = 'New password and confirm password not match'
            // error.newPassword = 'New password must be greater or equal to 8'
        }

        dispatch({ type: 'ON_ERROR', payload: error })

        return !Object.keys(error).length
    }


    const handleClose = () => {
        setOpen(false);
        props.handleCloseModal()
    };

//   function  preventPast (){
//       console.log("ssss")
//         window.onload = () => {
//             const myPasswordInput = document.getElementById('mypassword');
//             myPasswordInput.onpaste = e => e.preventDefault();
//            }
//     }

    return (
        <div>
            <Modal
                aria-labelledby="transition-modal-title"
                aria-describedby="transition-modal-description"
                className={classes.modal}
                open={open}
                onClose={handleClose}
                closeAfterTransition
                BackdropComponent={Backdrop}
                BackdropProps={{
                    timeout: 500,
                }}
            >
                <Fade in={open}>
                    <div className='change-passsword-modal'>
                        <div className='cancle-change-password-panel'>
                            <p onClick={handleClose}>X</p>
                        </div>
                        <div style={{ alignSelf: 'end' }}><h2 style={{ fontSize: '30px', fontWeight: 'normal', fontFamily: 'Source Sans Pro,sans-serif', }}>Change Your Password</h2></div>
                        <form>
                            <div className="changepassword-modal-textfields">
                                <label>Email</label>
                                <input
                                    autoComplete="on"
                                    name="email"
                                    value={email}
                                    id="mypassword"
                                    // onChange={(e) => this.handleChange(e)}
                                    // onKeyDown={(e) => this.handleEnter(e)}
                                    placeholder="Email"
                                    disabled={true}
                                    required
                                ></input>
                                <label>Old Password</label>
                                <input
                                    autoComplete="on"
                                    type="password"
                                    name="password"
                                    value={currentPassword}
                                    id="mypassword"
                                    //   onKeyDown={(e) => this.handleEnter(e)}
                                    onChange={(e) => setCurrentPassword(e.target.value)}
                                    placeholder="Password"
                                    required
                                ></input>
                                {state.error.currentPassword && <span className="error">{state.error.currentPassword}</span>}
                                <label>New Password</label>
                                <input
                                    autoComplete="on"
                                    type="password"
                                    onCopy={false}
                                    name="password"
                                    value={newPassword}
                                    onPaste={false}
                                    id="mypassword"
                                    //   onKeyDown={(e) => this.handleEnter(e)}
                                    onChange={(e) => setNewPassword(e.target.value)}
                                    // onChange={(e) => this.handleChange(e)}
                                    placeholder="Password"
                                    required
                                ></input>
                                {state.error.newPassword && <span className="error">{state.error.newPassword}</span>}
                                <label>Confirm New Password</label>
                                <input
                                    autoComplete="on"
                                    type="password"
                                    name="password"
                                    value={confirmPassword}
                                    //   onKeyDown={(e) => this.handleEnter(e)}
                                    // onChange={(e) => this.handleChange(e)}
                                    onChange={(e) => setConfirmPassword(e.target.value)}
                                    placeholder="Password"
                                    required
                                ></input>
                                {state.error.confirmPassword && <span className="error">{state.error.confirmPassword}</span>}
                                {state.error.passwordMatch && <span className="error">{state.error.passwordMatch}</span>}
                                <Button
                                    variant="outlined"
                                    className="change-password-modal-btn"
                                    //   onClick={(e) => this.handleLogin(e)}
                                    onClick={handleChangePassword}
                                    disabled={props.isLoading}
                                >
                                    {props.isLoading ? "Changing Password..." : "Change Password"}
                                </Button>
                            </div>
                        </form>
                    </div>
                </Fade>
            </Modal>
        </div>
    );
}


const mapStateToProps = (state) => {
    return {
        isLoading: state.AuthReducer.isLoading,
    };
};

// const mapDispatchToprops = (dispatch) => {
//     return {
//         userChangePassword: (username, password, history) => {
//             dispatch(AuthMiddleware.userChangePassword(username, password, history));
//         },
//     };
// };

export default connect(mapStateToProps, null)(ChangePasswordAfterLogin);
